import { ArrowOutward, KeyboardArrowDown } from "@mui/icons-material"
import { Collapse, Divider, Fade, Grid, Theme, Typography, useMediaQuery } from "@mui/material"
import { useState } from "react"
import { MarketMobileTable, MarketTable } from "../components"
import { StyledPaper, socialLinks } from "../components/commons"
import StatsBox, { StatsBoxType } from "../components/commons/StatsBox"
import { MarketInstructionFour, MarketInstructionOne, MarketInstructionThree, MarketInstructionTwo } from "../components/market/assets"
import useGlobalStore from "../stores/global"
import { Link } from "react-router-dom"

const statsBoxPlaceHolder: StatsBoxType[] = [
  { title: 'Total Deposited', content: '0', type: 'dollar', tooltip: 'The total amount of funds deposited into Intersect.' },
  { title: 'Total Borrowed', content: '0', type: 'dollar', tooltip: 'The total amount of funds borrowed on Intersect.' },
  { title: 'Available Liquidity', content: '0', type: 'dollar', tooltip: 'The total amount of funds currently available for borrowing or withdrawing.' },
  { title: 'Assets', content: '0', type: 'number', minDecimals: 0 },
]

const Market = () => {
  const [openHowItWorksBanner, setOpenHowItWorksBanner] = useState<boolean>(false)
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const markets = useGlobalStore((state) => state.markets)
  console.log("page market:", markets)
  const handleHowItWorksBanner = () => {
    setOpenHowItWorksBanner(!openHowItWorksBanner)
  }

  const statsBox: StatsBoxType[] = markets ? statsBoxPlaceHolder.map((stats) => {
    let content: number | string = '0'
    switch (stats.title) {
      case 'Total Deposited':
        content = markets.reduce((acc, market) => acc + (Number(market.totalSupplied) * Number(market.price)), 0)
        break;
      case 'Total Borrowed':
        content = markets.reduce((acc, market) => acc + (Number(market.totalBorrowed) * Number(market.price)), 0)
        break;
      case 'Available Liquidity':
        const totalSupplied = markets.reduce((acc, market) => acc + (Number(market.totalSupplied) * Number(market.price)), 0)
        const totalBorrowed = markets.reduce((acc, market) => acc + (Number(market.totalBorrowed) * Number(market.price)), 0)
        content = Math.max(totalSupplied - totalBorrowed, 0)
        break;
      case 'Assets':
        content = markets.length.toString()
        break;
    }
    return { ...stats, content: content }
  }) : statsBoxPlaceHolder

  return (
    <Grid container rowGap={{ xs: 2, sm: 4 }}>
      <Fade in={true} timeout={400}>
        <Grid item container justifyContent={'space-between'} alignItems={'center'}>
          <Grid item sx={{ maxWidth: '100%' }}>
            <Typography variant="h4">NeoX Markets</Typography>
            <Typography sx={{ display: { sm: 'inline', xs: 'block' }, margin: { sm: 0, xs: '1rem 0rem' }, lineHeight: { xs: '1.5rem', sm: 1.6 } }} component={'span'} variant="h6">Deposit assets to earn yield and borrow against collateral.&nbsp; </Typography>
            <Typography component={'span'} variant="h6" color='brand.primary' onClick={handleHowItWorksBanner} sx={{ cursor: 'pointer' }}>
              How it works <KeyboardArrowDown sx={{ verticalAlign: 'sub', color: 'brand.primary' }} />
            </Typography>
            <Collapse in={openHowItWorksBanner}>
              <StyledPaper color='primary' sx={{ padding: '2rem', marginTop: '1rem' }}>
                <Typography variant="h5">
                  How Intersect Works
                </Typography>
                <Grid container textAlign={'center'} sx={{ padding: '1.5rem' }} gap={5} flexWrap={{ sm: 'nowrap', xs: 'wrap' }}>
                  <Grid item container xs={12} sm={3} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} flexWrap={'nowrap'}>
                    <Grid>
                      <MarketInstructionOne style={{ display: 'block', marginBottom: '1rem', minHeight: '10rem' }} />
                    </Grid>
                    <Grid item xs={6} sx={{ minWidth: 'fit-content' }}>
                      <Typography color='brand.primary' component={'span'}>
                        Deposit&nbsp;
                      </Typography>
                      <Typography color='text.primary' component={'span'}>
                        assets to earn yield and to use as collateral
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container xs={12} sm={3} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} flexWrap={'nowrap'}>
                    <Grid item>
                      <MarketInstructionTwo style={{ display: 'block', marginBottom: '1rem', minHeight: '10rem' }} />
                    </Grid>
                    <Grid item xs={6} sx={{ minWidth: 'fit-content' }}>
                      <Typography color='brand.primary' component={'span'}>
                        Borrow&nbsp;
                      </Typography>
                      <Typography color='text.primary' component={'span'}>
                        assets against your deposited collateral
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container xs={12} sm={3} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} flexWrap={'nowrap'}>
                    <Grid >
                      <MarketInstructionThree style={{ display: 'block', marginBottom: '1rem', minHeight: '10rem' }} />
                    </Grid>
                    <Grid item xs={6} sx={{ minWidth: 'fit-content' }}>
                      <Typography color='text.primary' component={'span'}>
                        Borrow up to maximum Loan-to-Value (LTV), which is calculated using your deposited assets x debt combination
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container xs={12} sm={3} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} flexWrap={'nowrap'}>
                    <Grid item sx={{ minWidth: 'fit-content' }}>
                      <MarketInstructionFour style={{ display: 'block', marginBottom: '1rem', minHeight: '10rem' }} />
                    </Grid>
                    <Grid item xs={6} sx={{ minWidth: 'fit-content' }}>
                      <Typography color='text.primary' component={'span'} sx={{ width: '100%' }}>
                        Exceeding the Liquidation LTV may cause your collateral to be liquidated, but you will retain the borrowed assets.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider sx={{ backgroundColor: 'text.secondary' }} />
                <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                  <Link to={socialLinks.docs} target='_blank' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <>
                      <Typography variant='r' color='brand.primary'>Learn More</Typography>
                      <ArrowOutward sx={{ color: 'brand.primary', verticalAlign: 'bottom', marginLeft: '0.2rem', fontSize: '1.3rem', marginBottom: '0.1rem' }} />
                    </>
                  </Link>
                </div>
              </StyledPaper>
            </Collapse>
          </Grid>
        </Grid>
      </Fade>

      <Grid item container spacing={{ xs: 1.2, sm: 3 }}>
        {
          statsBox.map((stats, index) => {
            return <Fade in={true} timeout={400 * (index + 1)}>
              <Grid item container width={'100%'} xs={6} lg={3}>
                <StatsBox key={stats.title} {...stats} />
              </Grid>
            </Fade>
          }
          )
        }
        <Grid item container spacing={3} sx={{ marginTop: { xs: '-1rem', sm: 'inherit' } }}>
          {
            isMobile ? <Fade in={true} timeout={400}>
              <Grid item xs={12}>
                <MarketMobileTable title={"All Assets"} />
              </Grid>
            </Fade> :
              <>
                <Fade in={true} timeout={800}>
                  <Grid item xs={12}>
                    <MarketTable title={'All Assets'} />
                  </Grid>
                </Fade>
              </>
          }

        </Grid>
      </Grid>
    </Grid >
  )
}

export default Market